import {operations, client, handleDataOrError} from '@freckle/educator-entities/ts/fancy-api-client'

export type SharedOrTransferredStudentT = Omit<
  operations['getStudentsSharesR']['responses'][200]['content']['application/json'][0],
  'createdAt'
>

export const fetchSharedOrTransferredStudents = (): Promise<Array<SharedOrTransferredStudentT>> =>
  client.GET('/2/student-shares').then(handleDataOrError)
